import { useState, useEffect } from 'react';

function useSkeleton(isLoading: boolean) {
	const [delayedLoading, setDelayedLoading] = useState(false);

	useEffect(() => {
		if (isLoading) {
			setDelayedLoading(true);
		} else {
			const delayTimeout = setTimeout(() => {
				setDelayedLoading(false);
			}, 400);

			return () => clearTimeout(delayTimeout);
		}
	}, [isLoading]);

	return delayedLoading;
}

export default useSkeleton;
